import styled from 'styled-components'
import { FormGroup } from '../styles/shared'

export const SelectFormGroup = styled(FormGroup)`
  position: relative;
`

export const InfoLinkText = styled.span`
  font-size: 12px;
`

export const InfoLink = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0090D3;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: color 0.2s ease-in-out;

  ${props => props.disabled && `
    color: #9e9e9e;
    cursor: not-allowed;
  `}
`
